import type { ExtendedPartTagType } from '@/entities/rubrics';

const ALL_RUBRIC_SLUG = 'all';

export type TRubricSelectionFilterState = {
  selected_rubric: ExtendedPartTagType | null;
  tag__slugs: string | null;
};

export const applyRubricSelectionState = (state: TRubricSelectionFilterState, rubric: ExtendedPartTagType) => {
  state.selected_rubric = rubric;
  state.tag__slugs = rubric.value === ALL_RUBRIC_SLUG ? null : rubric.value;
};
